import axios from "axios";
import domain from "@/util/domain.js";
import {
  getIntegrationIdByName,
  addUserIntegration
} from "./integrationsUtils.js";

const host = domain();
// Access-Control-Allow-* são headers de resposta: enviados na requisição só
// aumentam a lista que o preflight do API Gateway precisa liberar.
const headers = {
  "Content-Type": "application/json"
};
// Stack sga-lambda-zendesk-prod (us-east-2). Não há stack de dev em us-east-2:
// o "dev" fica nulo para que um operador de teste nunca grave no Zendesk de prd.
const baseLambdaURLs = {
  dev: null,
  prod: "https://2z57kljp3f.execute-api.us-east-2.amazonaws.com",
};
let operator;
const zendeskIntegrationId = getIntegrationIdByName("zendesk");

//? Constructor Zendesk
//* https://developer.zendesk.com/api-reference/
class Zendesk {
  constructor(
    zendeskActive = false,
    createUser = false,
    confirmRegister = false,
    firstDeposit = false,
    baseLambdaURL = baseLambdaURLs.prod
  ) {
    this.zendeskActive = zendeskActive;
    this.baseLambdaURL = baseLambdaURL;
    this.createUser = createUser;
    this.confirmRegister = confirmRegister;
    this.firstDeposit = firstDeposit;
  }
}

//? Integrando ao Vue
export default {
  install(Vue) {
    Vue.prototype.$zendesk = async (action, userData, userId) => {
      //? Montando o Construtor do operador
      switch (host) {
        case "sysbet":
          operator = new Zendesk(false, true, true, true, baseLambdaURLs.dev);
          break;
        case "pingolbet":
        // case "betdasorte":
          operator = new Zendesk(true, true, true, true);
          break;
        default:
          operator = new Zendesk();
      }

      if (!operator.zendeskActive) return;

      //? Criação de Usuário - createUser
      if (action === "createUser" && operator.createUser) {
        const responseCreateUser = await createUser(userData, userId);

        if (responseCreateUser.status !== 200) return;

        // Adicionando ID do usuário do Zendesk no banco de dados para que
        // quando o usuário confirmar sua conta, esse ID seja utilizado para
        // atualizar o status de confirmação de conta nos dados do usuário no
        // zendesk
        const userIdZendesk = responseCreateUser.data.userIdZendesk;

        addUserIntegration(userId, userIdZendesk, "zendesk");
      }

      //? Confirmação de Conta - confirmRegister
      if (action === "confirmRegister" && operator.confirmRegister) {
        const userIntegrations = userData.integrations;

        if (userIntegrations && userIntegrations.length !== 0) {
          const hasIntegrationId = userIntegrations.find((integration) => {
            const { integration_id, user_integration_id } = integration;

            return zendeskIntegrationId === integration_id &&
              user_integration_id;
          });

          if (!hasIntegrationId) return;

          const responseUpdateUser =
            await updateUser(hasIntegrationId, "confirmRegister");

          if (responseUpdateUser.status !== 200) return;
        }

        return;
      }

      //? Primeiro Depósito - firstDeposit
      if (action === "firstDeposit" && operator.firstDeposit) {
        Vue.prototype.$axios.post(
          "/player/profile/findPlayerIntegrationId",
          Vue.prototype.$formdata({ integration_id: zendeskIntegrationId })
        ).then(async resp => {
          const respUserData = resp.data.dados;

          if (!respUserData.user_integration_id) return;

          const responseUpdateUser =
            await updateUser(respUserData, "firstDeposit");

          if (responseUpdateUser.status !== 200) return;
        }).catch(() => {});
      }
    };
  }
};

//? Create User
//* https://developer.zendesk.com/api-reference/ticketing/users/users/#create-user
const createUser = async (userData, userId) => {
  return new Promise(function (resolve, reject) {
    const body = {
      domain: userData.domain,
      user: {
        nome: userData.nome,
        email: userData.email,
        celular: userData.celular,
        cpf: userData.cpf,
        login: userData.login,
        userId
      }
    };

      axios
        .post(`${operator.baseLambdaURL}/createUserZendesk`, body, { headers })
        .then((resp) => resolve(resp))
        .catch((err) => reject(err));
  });
};

//? Update User Field
//* https://developer.zendesk.com/api-reference/ticketing/ticket-management/tags/#add-tags
//* https://developer.zendesk.com/api-reference/ticketing/ticket-management/tags/#remove-tags
const updateUser = async (userData, typeData) => {
  return new Promise(function (resolve, reject) {
    const body = {
      domain: domain(),
      userIdZendesk: userData.user_integration_id,
      typeData
    };

    axios
      .post(`${operator.baseLambdaURL}/updateUserZendesk`, body, { headers })
      .then((resp) => resolve(resp))
      .catch((err) => reject(err));
  });
};